module.exports = __webpack_public_path__ + "static/media/TownHall2.985fdeca.jpg";